import React from "react"
import IconPackage from 'xiv-fanfes-2021'
import styled from '@emotion/styled'
import { useLocalization } from 'gatsby-theme-i18n';
import * as breakpoint from '../../styles/breakpoints.module.scss';
import LinkItem from "../LinkItem/LinkItem";


const SocialMedia = () => {

  const { t } = useLocalization();
  
  return(
  <SocialMediaWrapper>
    {t('nav.sns.twitter.url') !== "" &&
      <SocialMediaLink href={t('nav.sns.twitter.url')} className={'twitter'}>
        <IconPackage.Icon type={'Twitter'} alt={t('nav.sns.twitter.label')} />
      </SocialMediaLink>
    }
    {t('nav.sns.facebook.url') !== "" &&
      <SocialMediaLink href={t('nav.sns.facebook.url')} className={'facebook'}>
        <IconPackage.Icon type={'Facebook'} alt={t('nav.sns.facebook.label')} />
      </SocialMediaLink>
    }
    {t('nav.sns.line.url') !== "" &&
      <SocialMediaLink href={t('nav.sns.line.url')} className={'line'}>
        <IconPackage.Icon type={'Line'} alt={t('nav.sns.line.label')} />
      </SocialMediaLink>
    }
    {t('nav.sns.instagram.url') !== "" &&
      <SocialMediaLink href={t('nav.sns.instagram.url')} className={'instagram'}>
        <IconPackage.Icon type={'Instagram'} alt={t('nav.sns.instagram.label')} />
      </SocialMediaLink>
    }
    {t('nav.sns.youtube.url') !== "" &&
      <SocialMediaLink href={t('nav.sns.youtube.url')} className={'youtube'}>
        <IconPackage.Icon type={'Youtube'} alt={t('nav.sns.youtube.label')} />
      </SocialMediaLink>
    }
    {t('nav.sns.twitch.url') !== "" &&
      <SocialMediaLink href={t('nav.sns.twitch.url')} className={'twitch'}>
        <IconPackage.Icon type={'Twitch'} alt={t('nav.sns.twitch.label')} />
      </SocialMediaLink>
    }
  </SocialMediaWrapper>)
}

export default SocialMedia;

const SocialMediaWrapper = styled.nav`
  margin:0 auto;
  text-align:right;
  position:absolute;
  bottom:0;
  right:0;

  @media only screen and (max-width: ${breakpoint.smMax}){
    position:relative;
    bottom:auto;
    right:auto;
    text-align:center;
    margin-top:20px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    display:flex;
    margin-top:0px;
    justify-content:space-between;
    padding:0 24px;
  }
`

const SocialMediaLink = styled(LinkItem)`
  display:inline-block;
  color:#ECECF0;
  margin:0 12px;
  height:24px;
  width:24px;
  line-height:30px;
  border-radius:3px;
  text-align:center;

  transition: color .2s;

  > svg{
    height:24px;
    width:24px;
  }

  &:last-of-type{
    margin-right:0;
  }


  &:hover{
   color:#ECECF0;
    
    &.facebook{
      color:#1877F2;
    }
    &.twitter{
      color:#1DA1F2;
    }
    &.youtube{
      color:#ff0000
    }
    &.twitch{
      color:#9146FF
    }
    &.line{
      color:#00c300
    }
  }

  &:active{
    opacity:.5;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin:0;
  }
`
